import React from 'react';

interface ToastProps {
  message: string;
  type?: 'success' | 'error' | 'info';
  onClose: () => void;
}

const getBgColor = (type: string) => {
  switch (type) {
    case 'success':
      return '#10b981'; // verde
    case 'error':
      return '#ef4444'; // vermelho
    case 'info':
    default:
      return '#a2449c'; // roxo
  }
};

const Toast: React.FC<ToastProps> = ({ message, type = 'info', onClose }) => {
  React.useEffect(() => {
    const timer = setTimeout(onClose, 3500);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 24,
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          background: getBgColor(type),
          color: 'white',
          borderRadius: 12,
          boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
          padding: '16px 24px',
          minWidth: 220,
          maxWidth: 600,
          width: '95vw',
          fontSize: 16,
          fontWeight: 500,
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          pointerEvents: 'auto',
          animation: 'toastSlideIn 0.3s',
        }}
        role="alert"
      >
        {type === 'success' && <i className="fas fa-check-circle"></i>}
        {type === 'error' && <i className="fas fa-exclamation-triangle"></i>}
        {type === 'info' && <i className="fas fa-info-circle"></i>}
        <span style={{ flex: 1 }}>{message}</span>
        <button
          onClick={onClose}
          style={{ background: 'none', border: 'none', color: 'white', fontSize: 18, cursor: 'pointer' }}
          aria-label="Fechar"
        >
          <i className="fas fa-times"></i>
        </button>
      </div>
      <style>{`
        @keyframes toastSlideIn {
          from { transform: translateY(60px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default Toast; 